import { useEffect, useState, useRef, useCallback } from "react";
import {
  AcceptPost,
  CancelPost,
  DeletePost,
  GetAllPostByUser,
  RejectPost,
} from "../services/PostService";
import { useDispatch } from "react-redux";
import { setErrorMessage, setSuccessMessage } from "../slices/messageSlice";
import ActivityItem from "../components/ActivityItem";
import { StatisticalPost } from "../services/ReportService";
import Statistical from "../components/Statistical";
import * as XLSX from "xlsx";
const ITEMS_PER_PAGE = 3;

const ManagePost = () => {
  const [activities, setActivities] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [searchId, setSearchId] = useState("");
  const [foundation, setFoundation] = useState("");
  const [status, setStatus] = useState("");
  const [linkResult, setLinkResult] = useState("");
  const [createAtFrom, setCreatedAtFrom] = useState("");
  const [createAtTo, setCreatedAtTo] = useState("");
  const [isRejectPopupOpen, setIsRejectPopupOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [currentActivityId, setCurrentActivityId] = useState(null);
  const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState(false);
  const [actionToConfirm, setActionToConfirm] = useState(null);
  const [statisticalData, setStatisticalData] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const observer = useRef();
  const dispatch = useDispatch();
  const activitiesRef = useRef(null);

  const lastActivityElementRef = useCallback(
    (node) => {
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [hasMore]
  );

  const fetchData = async (page) => {
    const response = await GetAllPostByUser(
      page,
      ITEMS_PER_PAGE,
      searchId,
      foundation,
      status,
      linkResult,
      createAtFrom,
      createAtTo
    );
    if (response.status_code === 200) {
      if (response.data.data === "[]" || typeof response.data.data == String) {
        setHasMore(false);
      } else {
        setActivities((prev) => [...prev, ...response.data.data]);
        setHasMore(page < response.data.page_max);
        setTotalItems(response.data.totals);
      }
    } else {
      dispatch(setErrorMessage(response.message));
    }
  };

  const fetchStatisticalPost = async () => {
    const response = await StatisticalPost(
      searchId,
      foundation,
      linkResult,
      status,
      createAtFrom,
      createAtTo
    );
    if (response.status_code === 200) {
      setStatisticalData(response.data.totals);
    } else {
      dispatch(setErrorMessage(response.message));
    }
  };
  const fetchNewData = async (page) => {
    setActivities([]);
    const response = await GetAllPostByUser(
      page,
      ITEMS_PER_PAGE,
      searchId,
      foundation,
      status,
      linkResult,
      createAtFrom,
      createAtTo
    );
    if (response.status_code === 200) {
      if (response.data.data === "[]" || typeof response.data.data == String) {
        setActivities([]);
        setHasMore(false);
      } else {
        setActivities(response.data.data);
        setHasMore(page < response.data.page_max);
        setTotalItems(response.data.totals);
      }
    } else {
      dispatch(setErrorMessage(response.message));
    }
  };

  useEffect(() => {
    fetchData(page);
  }, [dispatch, page]);

  useEffect(() => {
    setPage(1);
    fetchNewData(1);
    fetchStatisticalPost();
  }, [status, foundation, searchId, linkResult, createAtFrom, createAtTo]);

  const handleAction = (id, action) => {
    setCurrentActivityId(id);
    setActionToConfirm(action);
    setIsConfirmPopupOpen(true);
  };

  const confirmAction = async () => {
    let response;
    let updatedActivities;

    const scrollTop = activitiesRef.current.scrollTop;

    if (actionToConfirm === "accept") {
      response = await AcceptPost(currentActivityId);
      if (response.status_code === 200) {
        updatedActivities = activities.map((activity) =>
          activity.id === currentActivityId
            ? { ...activity, status: 1 }
            : activity
        );
        setActivities(updatedActivities);
      }
    } else if (actionToConfirm === "cancel") {
      response = await CancelPost(currentActivityId);
      if (response.status_code === 200) {
        updatedActivities = activities.map((activity) =>
          activity.id === currentActivityId
            ? { ...activity, status: 3 }
            : activity
        );
        setActivities(updatedActivities);
      }
    } else if (actionToConfirm === "reject") {
      setIsRejectPopupOpen(true);
      return;
    }

    if (response && response.status_code === 200) {
      activitiesRef.current.scrollTop = scrollTop;
      dispatch(
        setSuccessMessage("Thực hiện hành động với hoạt động thành công.")
      );
    } else {
      dispatch(setErrorMessage(response.message));
    }
    setIsConfirmPopupOpen(false);
  };

  const handleDelele = async (id) => {
    setCurrentActivityId(id);
    setActionToConfirm("delete");
    setIsConfirmPopupOpen(true);
  };

  const handleRejectClick = (id) => {
    setCurrentActivityId(id);
    setIsRejectPopupOpen(true);
  };

  const handleRejectSubmit = async () => {
    let updatedActivities;
    const scrollTop = activitiesRef.current.scrollTop;
    const response = await RejectPost(currentActivityId, rejectReason);
    if (response.status_code === 200) {
      updatedActivities = activities.map((activity) =>
        activity.id === currentActivityId
          ? { ...activity, status: 2, reasonNoneValid: rejectReason }
          : activity
      );
      setActivities(updatedActivities);
      activitiesRef.current.scrollTop = scrollTop;
      dispatch(setSuccessMessage("Đã từ chối hoạt động thành công."));
    } else {
      dispatch(setErrorMessage(response.message));
    }
    setIsRejectPopupOpen(false);
    setRejectReason("");
  };

  const getStatusPost = (status) => {
    if (status == 0) {
      return "Chờ Duyệt";
    }
    if (status == 1) {
      return "Đã Duyệt";
    }
    return "Từ Chối";
  };
  const handleDownload = async () => {
    setIsDownloading(true);
    const response = await GetAllPostByUser(
      1,
      totalItems,
      searchId,
      foundation,
      status,
      linkResult,
      createAtFrom,
      createAtTo
    );
    if (response.status_code === 200) {
      const data = response.data.data;
      const excelData = data.map((post, index) => ({
        STT: index + 1,
        "Mã KH": post?.creatorInfo?.code,
        Họ: post?.creatorInfo.firstName,
        Tên: post?.creatorInfo.lastName,
        Sđt: post?.creatorInfo.phoneNumber,
        "Nền tảng": post.foundation,
        "Trạng thái": getStatusPost(post.status),
        "Ngày đăng bài": post.createdAt,
        "Lý do từ chối": post.reasonNoneValid,
      }));
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);
      const colWidths = [
        { wch: 5 },
        { wch: 15 },
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 20 },
        { wch: 60 },
      ];
      ws["!cols"] = colWidths;
      // Thêm worksheet vào workbook
      XLSX.utils.book_append_sheet(wb, ws, "Danh sách bài đăng");
      const fileName = `danh_sach_bai_dang.xlsx`;
      XLSX.writeFile(wb, fileName);
    } else {
      dispatch(setErrorMessage(response.message));
    }

    setIsDownloading(false);
  };
  return (
    <div className="flex justify-center w-screen min-h-screen bg-white text-black dark:bg-gray-900 dark:text-white">
      <div className="max-w-[1200px] w-full flex flex-col bg-white dark:bg-gray-800 p-4">
        <div className="relative flex justify-center">
          <h1 className="text-2xl font-bold text-center my-4">
            QUẢN LÝ BÀI ĐĂNG
          </h1>
          <button
            className="absolute right-0 px-4 py-2.5 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors duration-200 flex items-center space-x-2 dark:bg-green-600 dark:hover:bg-green-700"
            onClick={handleDownload}
            disabled={isDownloading}
          >
            {isDownloading ? (
              <div className="flex items-center space-x-2">
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <span>Đang tải...</span>
              </div>
            ) : (
              <>
                <i className="fas fa-download"></i>
                <span>Tải xuống</span>
              </>
            )}
          </button>
        </div>

        {/* Main content container with flex layout */}
        <div className="flex gap-4">
          {/* Left side - Statistics */}
          {statisticalData && <Statistical statisticalData={statisticalData} />}

          {/* Right side - Filters and Content */}
          <div className="flex-1">
            {/* Filter Section */}
            <div className="grid grid-cols-3 gap-3 mb-4 p-3 bg-white rounded-lg shadow-sm dark:bg-gray-700">
              <div className="flex flex-col space-y-1">
                <label className="text-xs font-medium">ID:</label>
                <input
                  type="text"
                  value={searchId}
                  onChange={(e) => setSearchId(e.target.value)}
                  className="p-1.5 text-sm border rounded bg-white text-black dark:bg-gray-600 dark:text-white"
                  placeholder="Nhập ID"
                />
              </div>

              <div className="flex flex-col space-y-1">
                <label className="text-xs font-medium">Mã bài đăng:</label>
                <input
                  type="text"
                  value={linkResult}
                  onChange={(e) => setLinkResult(e.target.value)}
                  className="p-1.5 text-sm border rounded bg-white text-black dark:bg-gray-600 dark:text-white"
                  placeholder="Nhập mã bài"
                />
              </div>

              <div className="flex flex-col space-y-1">
                <label className="text-xs font-medium">Nền tảng:</label>
                <select
                  value={foundation}
                  onChange={(e) => setFoundation(e.target.value)}
                  className="p-1.5 text-sm border rounded bg-white text-black dark:bg-gray-600 dark:text-white"
                >
                  <option value="">Tất cả</option>
                  <option value="Facebook">Facebook</option>
                  <option value="Zalo">Zalo</option>
                  <option value="Other">Khác</option>
                </select>
              </div>

              <div className="flex flex-col space-y-1">
                <label className="text-xs font-medium">Trạng thái:</label>
                <select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  className="p-1.5 text-sm border rounded bg-white text-black dark:bg-gray-600 dark:text-white"
                >
                  <option value="">Tất cả</option>
                  <option value="0">Chờ duyệt</option>
                  <option value="1">Đã duyệt</option>
                  <option value="2">Đã từ chối</option>
                  <option value="3">Đã hủy</option>
                </select>
              </div>

              <div className="flex flex-col space-y-1">
                <label className="text-xs font-medium">Từ ngày:</label>
                <input
                  type="date"
                  value={createAtFrom}
                  onChange={(e) => setCreatedAtFrom(e.target.value)}
                  className="p-1.5 text-sm border rounded bg-white text-black dark:bg-gray-600 dark:text-white"
                />
              </div>

              <div className="flex flex-col space-y-1">
                <label className="text-xs font-medium">Đến ngày:</label>
                <input
                  type="date"
                  value={createAtTo}
                  onChange={(e) => setCreatedAtTo(e.target.value)}
                  className="p-1.5 text-sm border rounded bg-white text-black dark:bg-gray-600 dark:text-white"
                />
              </div>
            </div>

            {/* Activities list will go here */}
            <div>
              <div
                ref={activitiesRef}
                className="flex flex-col items-center px-4 max-h-screen overflow-y-auto"
              >
                <div className="w-full space-y-4">
                  {activities.length > 0 ? (
                    activities.map((act, index) => (
                      <div
                        key={act.id}
                        ref={
                          index === activities.length - 1
                            ? lastActivityElementRef
                            : null
                        }
                        className="bg-white rounded-lg shadow-md p-4 dark:bg-gray-700"
                      >
                        <ActivityItem activity={act} onDelete={handleAction} />
                        <div className="action-buttons mt-4 flex flex-col md:flex-row md:space-x-2">
                          {act.status !== 1 && (
                            <div className="flex space-x-2">
                              <button
                                onClick={() => handleAction(act.id, "accept")}
                                className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                              >
                                Chấp nhận
                              </button>
                            </div>
                          )}
                          <div className="flex space-x-2">
                            <button
                              onClick={() => handleRejectClick(act.id)}
                              className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                            >
                              Từ chối
                            </button>
                          </div>
                          {act.status !== 3 && (
                            <div className="flex space-x-2">
                              <button
                                onClick={() => handleAction(act.id, "cancel")}
                                className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600"
                              >
                                Hủy
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div>Không có hoạt động nào</div>
                  )}
                  {hasMore && (
                    <div className="flex w-full justify-center flex-col items-center">
                      <svg
                        aria-hidden="true"
                        className="inline w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-green-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                      <h2>Đang tải dữ liệu...</h2>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Popup xác nhận */}
        {isConfirmPopupOpen && (
          <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
            onClick={() => setIsConfirmPopupOpen(false)}
          >
            <div
              className="bg-white p-6 rounded-lg shadow-lg min-w-64 lg:min-w-96 dark:bg-gray-800 dark:text-white"
              onClick={(e) => e.stopPropagation()}
            >
              <h2 className="text-lg font-bold mb-4">Xác nhận hành động</h2>
              <p>{`Bạn có chắc chắn muốn ${
                actionToConfirm === "accept" ? "Chấp nhận" : "Hủy"
              } bài đăng này?`}</p>
              <div className="mt-4 flex justify-end">
                <button
                  onClick={() => setIsConfirmPopupOpen(false)}
                  className="bg-gray-300 text-gray-700 px-4 py-2 rounded mr-2 dark:bg-gray-600 dark:text-white"
                >
                  Hủy
                </button>
                <button
                  onClick={confirmAction}
                  className="bg-blue-500 text-white px-4 py-2 rounded"
                >
                  Xác nhận
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Popup từ chối */}
        {isRejectPopupOpen && (
          <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
            onClick={() => setIsRejectPopupOpen(false)}
          >
            <div
              className="bg-white p-6 rounded-lg shadow-lg min-w-64 lg:min-w-96 dark:bg-gray-800 dark:text-white"
              onClick={(e) => e.stopPropagation()}
            >
              <h2 className="text-lg font-bold mb-4">Lý do từ chối</h2>
              <textarea
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                className="w-full border rounded p-2 dark:bg-gray-600 dark:text-white"
                rows="4"
                placeholder="Nhập lý do từ chối..."
              />
              <div className="mt-4 flex justify-end">
                <button
                  onClick={() => setIsRejectPopupOpen(false)}
                  className="bg-gray-300 text-gray-700 px-4 py-2 rounded mr-2 dark:bg-gray-600 dark:text-white"
                >
                  Hủy
                </button>
                <button
                  onClick={handleRejectSubmit}
                  className="bg-red-500 text-white px-4 py-2 rounded"
                >
                  Từ chối
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ManagePost;
